export const DISTANCE_OPTIONS = ['5', '10', '15', '25', '50', '100'];
